import React from 'react';
export const TrainingPositioning = () => {
  return <section className="py-20 bg-gray-50" data-id="element-1278" data-mp="2whhg18oghd3h">
      <div className="container mx-auto px-4" data-id="element-1279" data-mp="3e3wdxy94xive">
        <div className="max-w-4xl mx-auto text-center scroll-animate" data-id="element-1280" data-mp="3e34g0gs2f91y">
          <h2 className="text-3xl md:text-5xl font-bold text-navy mb-8 font-heading" data-id="element-1281" data-mp="3sr91fsii5yof">
            Future-Ready Skills for Modern Teams
          </h2>
          <div className="space-y-6 text-lg md:text-xl text-gray-700 font-sans leading-relaxed" data-id="element-1282" data-mp="3nvjzjij0g5oy">
            <p data-id="element-1283" data-mp="305g4hzjw1e9k">
              The Networking Salon helps institutions build smarter, more
              capable teams through practical training in AI, communications,
              leadership, networking, digital growth, and program development.
            </p>
            <p data-id="element-1284" data-mp="3514xfk1ejwww">
              Our programs are designed for organizations that want to equip
              their people with the skills needed to thrive in a rapidly
              evolving world.
            </p>
          </div>
        </div>
      </div>
    </section>;
};